import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import GroupFeed from '../components/groups/GroupFeed';
import GroupMembers from '../components/groups/GroupMembers';
import GroupFiles from '../components/groups/GroupFiles';
import GroupNotes from '../components/groups/GroupNotes';
import AlgaWeeklySummaryWidget from '../components/groups/AlgaWeeklySummaryWidget';
import { UsersIcon, MessageSquareIcon, TrendingUpIcon, XIcon } from 'lucide-react';
// Temporary data - should come from a proper data source
const groupData = {
  id: 1,
  name: 'Circular Economy Hub',
  description: "Gruppo dedicato all'economia circolare e alla gestione sostenibile delle risorse.",
  courseImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sMwaciLMqhGLjESiGb7Pkn/IMG_0019.jpg',
  members: 234,
  posts: 156,
  activeMembers: 89,
  courseName: 'Circular Economy Management'
};
const GroupDetailPage = () => {
  const [activeTab, setActiveTab] = useState('feed');
  const {
    groupId
  } = useParams();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const renderContent = () => {
    switch (activeTab) {
      case 'feed':
        return <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1703">
            <div className="md:col-span-2" data-id="element-1704">
              <GroupFeed groupId={groupId} data-id="element-1705" />
            </div>
            <div className="md:col-span-1" data-id="element-1706">
              <AlgaWeeklySummaryWidget data-id="element-1707" />
            </div>
          </div>;
      case 'members':
        return <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1708">
            <div className="md:col-span-2" data-id="element-1709">
              <GroupMembers groupId={groupId} data-id="element-1710" />
            </div>
            <div className="md:col-span-1" data-id="element-1711">
              <AlgaWeeklySummaryWidget data-id="element-1712" />
            </div>
          </div>;
      case 'files':
        return <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1713">
            <div className="md:col-span-2" data-id="element-1714">
              <GroupFiles groupId={groupId} data-id="element-1715" />
            </div>
            <div className="md:col-span-1" data-id="element-1716">
              <AlgaWeeklySummaryWidget data-id="element-1717" />
            </div>
          </div>;
      case 'notes':
        return <GroupNotes groupId={groupId} data-id="element-1718" />;
      default:
        return <GroupFeed groupId={groupId} data-id="element-1719" />;
    }
  };
  return <div className="flex h-screen bg-gray-100" data-id="element-1720">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 md:hidden ${sidebarOpen ? 'block' : 'hidden'}`} data-id="element-1721">
        {/* Sidebar backdrop */}
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-1722"></div>
        {/* Sidebar */}
        <div className="relative flex-1 flex flex-col w-2/3 h-full bg-black" data-id="element-1723">
          <div className="absolute top-0 right-0 -mr-12 pt-2" data-id="element-1724">
            <button type="button" className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setSidebarOpen(false)} data-id="element-1725">
              <span className="sr-only" data-id="element-1726">Close sidebar</span>
              <XIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-1727" />
            </button>
          </div>
          <div className="flex-1 h-full overflow-y-auto" data-id="element-1728">
            <Sidebar activePage="community" data-id="element-1729" />
          </div>
        </div>
      </div>
      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-1730">
        <Sidebar activePage="community" data-id="element-1731" />
      </div>
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-1732">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-1733" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 pt-0 md:pt-0 bg-gray-100" data-id="element-1734">
          <div className="max-w-6xl mx-auto pt-4 md:pt-6" data-id="element-1735">
            {/* Group Header as a widget */}
            <div className="bg-white rounded-xl border border-gray-200 shadow-sm mb-6 overflow-hidden" data-id="element-1736">
              <div className="p-6" data-id="element-1737">
                <div className="flex flex-col sm:flex-row items-start gap-4" data-id="element-1738">
                  <div className="w-full sm:w-[100px] h-[120px] rounded-lg overflow-hidden flex-shrink-0" data-id="element-1739">
                    <img src={groupData.courseImage} alt={groupData.name} className="w-full h-full object-cover" data-id="element-1740" />
                  </div>
                  <div className="flex-1" data-id="element-1741">
                    <h1 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-1742">
                      {groupData.name}
                    </h1>
                    <p className="text-gray-600 mb-4 text-sm" data-id="element-1743">
                      {groupData.description}
                    </p>
                    <div className="flex flex-wrap items-center gap-4 sm:gap-6" data-id="element-1744">
                      <div className="flex items-center text-gray-500" data-id="element-1745">
                        <UsersIcon size={16} className="mr-1.5" data-id="element-1746" />
                        <span className="text-sm" data-id="element-1747">
                          {groupData.members} membri
                        </span>
                      </div>
                      <div className="flex items-center text-gray-500" data-id="element-1748">
                        <MessageSquareIcon size={16} className="mr-1.5" data-id="element-1749" />
                        <span className="text-sm" data-id="element-1750">{groupData.posts} post</span>
                      </div>
                      <div className="flex items-center text-gray-500" data-id="element-1751">
                        <TrendingUpIcon size={16} className="mr-1.5" data-id="element-1752" />
                        <span className="text-sm" data-id="element-1753">
                          {groupData.activeMembers} attivi
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Tab Navigation */}
              <div className="border-t border-gray-200 px-6 overflow-x-auto" data-id="element-1754">
                <nav className="flex space-x-8" data-id="element-1755">
                  <button onClick={() => setActiveTab('feed')} className={`py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${activeTab === 'feed' ? 'border-custom-green text-custom-green' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1756">
                    Feed
                  </button>
                  <button onClick={() => setActiveTab('members')} className={`py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${activeTab === 'members' ? 'border-custom-green text-custom-green' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1757">
                    Membri
                  </button>
                  <button onClick={() => setActiveTab('files')} className={`py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${activeTab === 'files' ? 'border-custom-green text-custom-green' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1758">
                    File
                  </button>
                  <button onClick={() => setActiveTab('notes')} className={`py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${activeTab === 'notes' ? 'border-custom-green text-custom-green' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1759">
                    Note
                  </button>
                </nav>
              </div>
            </div>
            {/* Content area */}
            {renderContent()}
          </div>
        </main>
      </div>
    </div>;
};
export default GroupDetailPage;